import * as React from "react"
import { assignInlineVars } from "@vanilla-extract/dynamic"
import { Link } from "gatsby"
import {
  IDropdownMenuItem,
  IDropdownMenuItemGroup,
  IDropdownMenuProps,
} from "./menus"
import * as styles from "./styles/dropdown-menu.css"

function DropdownMenuItem({
  href,
  icon,
  text,
  description,
  links,
}: IDropdownMenuItem) {
  return (
    <>
      <Link to={href} className={styles.itemLink}>
        <div className={styles.itemIcon}>{icon}</div>
        <div>
          <h2 className={styles.itemName}>{text}</h2>
          <p className={styles.itemDescription}>{description}</p>
        </div>
      </Link>
      {!!links?.length && (
        <ul className={styles.itemSublinks}>
          {links.map(link => (
            <li key={link.href} className={styles.itemSublinksItem}>
              <Link to={link.href} className={styles.itemSublink}>
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

function DropdownMenuItemList({ items }: { items: IDropdownMenuItem[] }) {
  return (
    <ul className={styles.list}>
      {(items as IDropdownMenuItem[]).map(item => (
        <li key={item.text} className={styles.item}>
          <DropdownMenuItem {...item} />
        </li>
      ))}
    </ul>
  )
}

function DropdownMenuItemGroupList({
  items,
  columns,
  rows,
}: {
  items: IDropdownMenuItemGroup[]
  columns?: number
  rows?: number
}) {
  return (
    <ul
      className={styles.listGroup}
      style={assignInlineVars({
        [styles.listGroupColumns]: `${columns}`,
        [styles.listGroupRows]: `${rows}`,
      })}
    >
      {items.map(item => (
        <li
          key={item.title}
          className={styles.item}
          style={assignInlineVars({
            [styles.listItemSpan]: `${item.span}`,
          })}
        >
          <div className={styles.listGroupWrapper}>
            <h1 className={styles.listGroupTitle}>{item.title}</h1>
            <DropdownMenuItemList items={item.items} />
          </div>
        </li>
      ))}
    </ul>
  )
}

export default function DropdownMenu({
  items = [],
  columns,
  rows,
}: IDropdownMenuProps) {
  const grouped = items.length > 0 && `title` in items[0]
  return (
    <div className={styles.root}>
      {grouped ? (
        <DropdownMenuItemGroupList
          items={items as IDropdownMenuItemGroup[]}
          columns={columns}
          rows={rows}
        />
      ) : (
        <DropdownMenuItemList items={items as IDropdownMenuItem[]} />
      )}
    </div>
  )
}
